<div class="content-section implementation">
  <div class="card">
    <p-table #dt [value]="inputTableData" class="p-datatable-gridlines , p-datatable-striped, p-datatable-sm" dataKey="id" [reorderableColumns]="true">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 2rem">Id</th>
          <th>Description</th>
          <th class="status-col" style="width: 4rem">Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-testData let-index="rowIndex">
        <tr>
          <td>{{ testData.id }}</td>
          <td>{{ testData.description | stripHtml: '' }}</td>
          <td class="status-col">
            <span class="status-icon" [ngStyle]="{ 'background-color': getStatusColor(testData) }"></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
